import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Image, Button as BaseButton, Text } from 'src/Components/Base';
import { EmptyView } from 'src/Components/MyDepartments';
import { SPACE } from 'src/Components/Theme';
import { getFacultyInfo } from 'src/GraphQL/query/UniFaculty.query.js';

const ScrollMark = styled(Box)`
  position: absolute;
  visibility: hidden;
  top: -115px;
`;

const Button = styled(BaseButton)`
  &.ui.basic.primary.button:hover,
  &.ui.basic.primary.buttons .button:hover {
    background-color: rgb(250, 250, 250) !important;
  }
`;

const ItemBox = styled(Box)`
  display: flex;
  align-items: center;
`;

const SelectedFacultyWrapper = styled(Box)`
  position: relative;
`;

const Stamp = styled(Box)`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 100px;
  height: 50px;
  background: url('images/confirm/stamped.png') center center no-repeat;
  background-size: contain;
`;

export class ConfirmFaculty extends Component {
  static propTypes = {
    deptId: PropTypes.string,
  };

  render() {
    const { id, facultyId, universityId, onChooseFacultyClick } = this.props;
    let data = undefined;
    if (
      facultyId !== undefined &&
      facultyId !== null &&
      universityId !== undefined &&
      universityId !== null
    ) {
      data = getFacultyInfo(universityId, facultyId);
    }
    return (
      <Box style={{ position: 'relative' }}>
        <ScrollMark id={id} />

        {facultyId !== undefined &&
        facultyId !== null &&
        universityId !== undefined &&
        universityId !== null ? (
          <SelectedFacultyWrapper>
            <ItemBox>
              <Image src={data.logo} maxWidth={'70px'} />
              <Box p={2}>
                <Text fontWeight={'bold'}>{data.university.name}</Text>
                <Text>{data.name}</Text>
              </Box>
            </ItemBox>
            <Stamp></Stamp>
          </SelectedFacultyWrapper>
        ) : (
          <EmptyView image="/images/redeem_empty.svg" text="ยังไม่ได้เลือกคณะที่สอบติด" />
        )}

        <Box mt={SPACE.medium}>
          <Button
            primary
            basic={facultyId !== null}
            circular
            style={{ width: '100%' }}
            onClick={onChooseFacultyClick}
          >
            <Text
              color={facultyId !== null ? 'primary' : 'white'}
              fontSize={3}
              fontWeight="bold"
              style={{ lineHeight: 1.2 }}
            >
              เลือกคณะที่สอบติด
            </Text>
          </Button>
        </Box>
      </Box>
    );
  }
}

export default ConfirmFaculty;
